var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-box"},[_c('div',{staticClass:"toggle"},[_vm._t("toggle",[_c('uSwitch',{on:{"toggle":_vm.toggle}})])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentVisible),expression:"contentVisible"}],staticClass:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5262f9bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toggleBox/toggleBox.vue
// module id = httJ
// module chunks = 33